import { render, staticRenderFns } from "./SalersResumeDetailTable.vue?vue&type=template&id=5e9833cf&"
import script from "./SalersResumeDetailTable.vue?vue&type=script&lang=js&"
export * from "./SalersResumeDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports